import React from "react";
import classNames from "classnames";
import styles from "./NumberedList.module.scss";
import _ from "lodash";
import { Span } from "./../../";

const NumberedList = ({children: _children = [], className, style, liClassName, liStyle, includeTitles}) => {
    const children = _.isArray(_children) ? _children : [_children];
    return <ul className={classNames(styles.base, className, {[styles['include-titles']]: includeTitles})} style={style}>
        {children.map((child, index) => {
            return child && <li key={index} className={classNames(styles.li, liClassName)} style={liStyle}>
                <Span bold color={includeTitles ? "text-primary" : undefined}>{index + 1}</Span>
                <div className={styles["divider"]}/>
                <span className={styles['text']}>{child}</span>
            </li>
        })}
    </ul>
};

export default NumberedList;